exports = module.exports = require("../../../../../legacy/web-builder/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".classificationMainView{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column}.map-container{position:relative;overflow:hidden;height:100%;width:100%}@media (min-width: 544px){.map-container{height:initial}}@media (min-width: 768px){.map-container{height:38rem;position:absolute;top:0}}@media (min-width: 992px){.map-container{height:43rem}}@media (min-width: 1200px){.map-container{height:42rem}}._1kctIxWXk24BBb9Pdrv77S i{font-size:1.5rem}\n", ""]);

// exports
exports.locals = {
	"iconSize": "_1kctIxWXk24BBb9Pdrv77S"
};